import { AuthBackgroundArts } from '@affine/component/auth-components';

export function SignInBackgroundArts() {
  return <AuthBackgroundArts />;
}
